import {useState, useEffect} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {ChevronLeft, ChevronRight} from 'lucide-react';
import {Link} from "react-router-dom";
import Service from "../../pages/Service";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import {useLanguageStore} from "../../store/languageStore";

export default function ServicesCarousel({data}) {
    const [swiper, setSwiper] = useState(null);
    const {language} = useLanguageStore();
    const isArabic = language === 'ar';
    const [showModal, setShowModal] = useState(false);
    const [modalInfo, setModalInfo] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);

   

    const goNext = () => {
        if (swiper) swiper.slideNext();
    };

    const goPrev = () => {
        if (swiper) swiper.slidePrev();
    };

    return (
        <div className="w-full bg-white py-12">
            <Service visbale={showModal} close={() => setShowModal(false)} modalInfo={modalInfo}/>
            <div className="container mx-auto px-4">
                <h2 className="text-3xl font-bold text-center mb-12">{isArabic ? 'خدماتنا' : 'Our Services'}</h2>

                <div className="relative">
                    <Swiper
                        onSwiper={setSwiper}
                        modules={[Pagination, Navigation, Autoplay]}
                        spaceBetween={20}
                        slidesPerView={1}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            clickable: true,
                            el: '.swiper-pagination',
                            bulletClass: 'swiper-pagination-bullet',
                            bulletActiveClass: 'swiper-pagination-bullet-active'
                        }}
                        breakpoints={{
                            640: {
                                slidesPerView: 2,
                            },
                            1024: {
                                slidesPerView: 3,
                            },
                            1280: {
                                slidesPerView: 4,
                            },
                        }}
                        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                        className="w-full"
                    >
                        {data.map((service) => (
                            <SwiperSlide key={service.id} className="max-h-fit">
                                <div
                                    onClick={() => {
                                        setModalInfo(service)
                                        setShowModal(true)
                                    }}
                                    dir={!isArabic ? 'ltr' : 'rtl'}
                                    className="bg-white rounded-lg shadow-md overflow-hidden h-full flex flex-col my-2">
                                    <div className="overflow-hidden p-5">
                                        <img loading="lazy"
                                            src={service.image}
                                            alt={service.title}
                                            className="w-full h-full object-cover rounded-lg"
                                        />
                                    </div>
                                    <div className="p-6 flex flex-col flex-grow">
                                        <h3 className="text-xl font-bold mb-3 text-gray-800 line-clamp-1">
                                            {isArabic ? service.services_name_ar : service.services_name_en}
                                        </h3>
                                        <p className="text-gray-600 flex-grow line-clamp-3">
                                            {isArabic ? service.description_ar.slice(0, 150) : service.description_en.slice(0, 150)}
                                        </p>
                                        <div className="mt-4 flex justify-end">
                                            <div className="text-teal-500">
                                                <img loading="lazy"
                                                    src={require('../../assest/cardServeceIcon.png')}
                                                    className={`w-10 ${isArabic ? 'transform rotate-180' : ''}`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <div className="flex justify-center">
                        <div className="swiper-pagination flex justify-center space-x-2 mt-2">
                            {data.map((_, index) => (
                                <button
                                    key={index}
                                    className={`w-3 h-3 rounded-full bg-gray-300 hover:bg-teal-500 focus:outline-none ${
                                        index === activeIndex ? 'bg-teal-500' : ''
                                    }`}
                                    onClick={() => swiper?.slideTo(index)}
                                />
                            ))}
                        </div>
                    </div>

                    <div
                        className="absolute left-0 right-0 top-1/2 transform -translate-y-1/2 flex justify-between pointer-events-none"
                    >
                        <button
                            onClick={goPrev}
                            className="bg-white rounded-full p-2 shadow-md pointer-events-auto focus:outline-none"
                        >
                            <ChevronLeft size={24} className="text-gray-600"/>
                        </button>
                        <button
                            onClick={goNext}
                            className="bg-white rounded-full p-2 shadow-md pointer-events-auto focus:outline-none"
                        >
                            <ChevronRight size={24} className="text-gray-600"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}